import { render } from "./NavContent.vue?vue&type=template&id=3149e4c0&scoped=true&lang=pug"
import script from "./NavContent.vue?vue&type=script&lang=js"
export * from "./NavContent.vue?vue&type=script&lang=js"

import "./NavContent.vue?vue&type=style&index=0&id=3149e4c0&lang=scss&scoped=true"

import exportComponent from "C:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3149e4c0"]])

export default __exports__